import { useEffect } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Box } from "rebass/styled-components";
import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getLeagueAdmin } from "core-integration/src/store/leagues/reducers";
import {
  fetchClassicLeagueForAdmin,
  updateClassicLeague,
} from "core-integration/src/store/leagues/thunks";
import {
  IPrivateLeagueAdmin,
  IUpdateClassicLeagueData,
} from "core-integration/src/store/leagues/types";
import Copy from "../Copy";
import { Main, Wrapper } from "../Layout";
import Title from "../Title";
import AddBan from "./admin/AddBan";
import ChangeAdmin from "./admin/ChangeAdmin";
import ClassicDetails from "./admin/ClassicDetails";
import Code from "./admin/Code";
import Delete from "./admin/Delete";
import RemoveBan from "./admin/RemoveBan";

type Props = WithTranslation;

const AdminClassic = ({ t }: Props) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const { leagueId } = useParams();

  const leagueNumber =
    leagueId && parseInt(leagueId, 10) ? parseInt(leagueId, 10) : 0;

  const league = useSelector((state: RootState) =>
    leagueNumber
      ? (getLeagueAdmin(state, leagueNumber) as IPrivateLeagueAdmin)
      : null,
  );

  useEffect(() => {
    if (leagueNumber) {
      dispatch(fetchClassicLeagueForAdmin(leagueNumber));
    }
  }, [dispatch, leagueNumber]);

  const updateLeague = (leagueId: number, data: IUpdateClassicLeagueData) =>
    dispatch(updateClassicLeague(leagueId, data));

  if (!league) {
    return null;
  }
  return (
    <Wrapper>
      <Main>
        <Copy>
          <Title>{t("leagues.adminTitle", "League Administration")}</Title>
          <Code league={league} />
          <Box mt={4}>
            <ClassicDetails league={league} />
          </Box>
          <Box mt={4}>
            <AddBan league={league} />
          </Box>
          <Box mt={4}>
            <RemoveBan league={league} />
          </Box>
          <Box mt={4}>
            <ChangeAdmin
              league={league}
              updateAdmin={(entryId: number) =>
                updateLeague(league.id, {
                  admin_entry: entryId,
                  closed: league.closed,
                  code_privacy: league.code_privacy,
                  name: league.name,
                  start_event: league.start_event,
                })
              }
            />
          </Box>
          <Box my={4}>
            <Delete league={league} />
          </Box>
        </Copy>
      </Main>
    </Wrapper>
  );
};

export default withTranslation()(AdminClassic);
